import React from 'react'

export default ({ className }) => (
    <svg className={className} width="17px" height="15px" viewBox="0 0 17 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
        <g id="7-9" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="RM---answering-autogen-question" transform="translate(-466.000000, -1213.000000)">
                <g id="writing-explanation" transform="translate(262.000000, 1028.000000)">
                    <g id="Group-3" transform="translate(0.000000, 44.000000)">
                        <rect id="Rectangle" stroke="#9B9B9B" strokeWidth="0.5" fill="#FFFFFF" x="0.25" y="0.25" width="697.5" height="166.5"></rect>
                        <g id="bin" transform="translate(204.814599, 141.000000)" stroke="#56565A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.625">
                            <path d="M13.0556569,2.1875 L13.0556569,14.0625 C13.0556569,14.407678 12.7705244,14.6875 12.4187956,14.6875 L2.86587591,14.6875 C2.51414712,14.6875 2.2290146,14.407678 2.2290146,14.0625 L2.2290146,2.1875" id="Path"></path>
                            <path d="M4.77645985,2.1875 L4.77645985,0.9375 C4.77645985,0.592322031 5.06159238,0.3125 5.41332117,0.3125 L9.87135036,0.3125 C10.2230792,0.3125 10.5082117,0.592322031 10.5082117,0.9375 L10.5082117,2.1875" id="Path"></path>
                            <path d="M0.318430657,2.1875 L14.9662409,2.1875" id="Path"></path>
                            <path d="M4.77645985,4.375 L4.77645985,11.875" id="Path"></path>
                            <path d="M7.64233577,4.375 L7.64233577,11.875" id="Path"></path>
                            <path d="M10.5082117,4.375 L10.5082117,11.875" id="Path"></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
)
